module.exports = __webpack_public_path__ + "transaction.svg?60850224ff9571051f9dcfca54fb5070";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/transaction.svg
// module id = 150
// module chunks = 0